export default __webpack_public_path__ + "static/fso-menu-16687dea0d84a1f2e76c8f986bc25b57.png";